import { EventEmitter } from "@angular/core";
import { stopAndPrevent } from "./input-utils";
import { isJsObject } from "./utils";
import { getClientRect } from "./web-utils";
import { MatDialogRef } from "@angular/material/dialog";
import { UntypedFormControl } from "@angular/forms";

export function proxyEvent<T = any>(evt: any, emitter: EventEmitter<T>) {
  if (isJsObject(evt) && emitter) {
    stopAndPrevent(evt);
    emitter.emit(evt);
  }
}

export function getDialogDims(): DOMRect | null {
  const elems = document.getElementsByClassName('mdc-dialog__container');
  if (elems.length) {
    return getClientRect(elems.item(0));
  }
  console.error('No dialog container')
  return null;
}

export function subClosed<T, R = any>(matDialogRef: MatDialogRef<T, R>, callback: (value: any) => void) {
  matDialogRef && matDialogRef.afterClosed().subscribe(callback);
}

export function findAndSetSelect(
  intValue: any,
  formControl: UntypedFormControl,
  values: any[]
) {
  if (Number.isFinite(intValue)) {
    const ded = values.find((item: any) => {
      return item.id === intValue;
    });
    ded && formControl.setValue(ded);
  }
}
